import React, { useContext, useEffect, useState } from 'react';
import store from '../../../../redux/store';
import { useNavigate } from 'react-router-dom';
import { AlertContext, Alert_, CardsSixty, Google_Search, Grey_Link, On_Click_Card, PageAlwaysVisible, PageDesktopOnly, PageIllu, PageSixty, PageSubtitle, PageTitle, Section_Search, Sixty_Card_Loader } from 'monica-alexandria';
import { Helmet } from 'react-helmet';
import { getCustomerClients } from '../../services/api/GoogleApi';
import i18n from '../../../../localization/i18next';
import { t } from 'i18next';

import dummyData from '../../data/dummyData.json';
import { AuthContext } from '../../../../services/authentication/Guard';
import { checkOwnership } from '../../../../helpers/verifyToolOwnership';
import { checkIfClientHasCampaigns } from './utils/checkIfClientHasCampaigns';

const environment = process.env.REACT_APP_SERVER;


const CLIENTS = () => {

    const lang = i18n.language ? i18n.language : 'en';
    const navigate = useNavigate();
    const auth = useContext(AuthContext);
    const userId = auth?.user?.sub;

    /* LocalStorage Data */
    const GoogleSourceData = store.getState().googleSource;
    const googleUserProfile = GoogleSourceData?.userProfile;
    const clientAccount = GoogleSourceData?.clientAccount;
    const managerAccount = GoogleSourceData?.managerAccount;
    const accessToken = googleUserProfile?.accessToken;
    const selectedManagerResource = managerAccount?.resourceName;

    /* For tool ownership validation */
    const [hasCheckOwnership, setHasCheckOwnership] = useState(false);

    /* Check if user has source accounts */
    const [userHasData, setUserHasData] = useState(true);

    const [customerClients, setCustomerClients] = useState([]);

    /* Search */ 
    const [searchResults, setSearchResults] = useState([]);
    const [displayedResults, setDisplayedResults] = useState([]);

    /* For loading client's campaigns */
    const [ isLoading, setIsLoading ] = useState(false);

    const { alerts, setAlerts } = useContext(AlertContext);

    const alertMessage = (message, status) => {
        setAlerts([
            ...alerts,
            {
                message: {
                    text: message,
                    status: status,
                },
            },
        ]);
    };

    /* Switch data assignment ( Real/Dummy ) */
    const initActions = () => {
        const get_Customer_Client_Resource_Names = () => {
            getCustomerClients(selectedManagerResource, accessToken)
                .then((response) => {
                    const clients = response?.data?.data?.customerClients;
                    if ( clients && clients?.length > 0 ) {
                        setCustomerClients(clients);
                        setDisplayedResults(clients);
                    }
                    else setUserHasData(false);
                })
                .catch(error=>{
                    console.error(error); 
                    setUserHasData(false);
                    alertMessage((t("Session expired")),'Error');
                    navigate(`/${lang}/google/connect`);
                })
        }

        if ( environment !== 'LOCAL' ) get_Customer_Client_Resource_Names()
        else {
            setCustomerClients(dummyData.getCustomerClients.customerClients);
            setDisplayedResults(dummyData.getCustomerClients.customerClients);
        }
    }

    const handleSelection = (client) => {
        setIsLoading(true);
        checkIfClientHasCampaigns(client?.customerClient?.resourceName, managerAccount.id, accessToken)
            .then((res) => {
                setIsLoading(false);
                if ( res?.hasCampaigns ) {
                    store.dispatch({type: "SAVE_GOOGLE_CLIENT_ACCOUNT", payload: {
                        ...clientAccount,
                        resourceName: client?.customerClient?.resourceName,
                        name: client?.customerClient?.descriptiveName,
                        id: client?.customerClient?.id, 
                    }})
                    alertMessage(t("Successfully found client's campaigns"), "Success");
                    navigate(`/${lang}/google/dates`);
                } else {
                    alertMessage(t("Client has not any past or active campaigns"), "Error");
                }
        }).catch(err=>{
            setIsLoading(false);
            console.error(err)
            alertMessage((t("Session expired")),'Error');
            navigate(`/${lang}/google/connect`);
        })
    }


    useEffect(() => {
        if ( isLoading ) alertMessage("Checking client's campaigns", "Loading");
    },[isLoading])


    useEffect(() => {
        if ( searchResults.input ) setDisplayedResults(searchResults.data);
        else setDisplayedResults(customerClients);
    },[searchResults])


    useEffect(() => {
        initActions();
    },[])

    /* Validate Tool Ownership */
    useEffect(() => {
        if (userId) checkOwnership(userId, navigate, lang, setHasCheckOwnership);
    }, [userId]);


  return (
    <>
        <Helmet>
            <title>Adsnap | Clients</title>
        </Helmet>
        <Alert_ messages={alerts} />
        { hasCheckOwnership && <PageSixty>
            <PageAlwaysVisible>
                <PageTitle>
                    <Grey_Link iconLeft="Back" id={"AdSnap_Google_Select_Client_1"} onClick={() => navigate(`/${lang}/google/source-account`)} noPadding />
                    <h1>{t('Select a Client')}</h1>
                </PageTitle>           
                <PageSubtitle>
                            <p>{t('Choose the Client you want to generate automated reports for')}</p>
                </PageSubtitle>
                
                {/* Google Search */}
                {customerClients?.length >= 10 ? (
                        <Section_Search title={t('Search for a client')}>
                            <Google_Search
                                file={customerClients}
                                fileKeys={['customerClient.descriptiveName', 'customerClient.id', 'customerClient.descriptiveName_reversed']}
                                defaultValue={''}
                                sanitize={true}
                                placeholder={t('Client')}
                                applyReverseFileProperties={[
                                    {
                                        originalKey: 'customerClient.descriptiveName',
                                        reversedKey: 'customerClient.descriptiveName_reversed',
                                    },
                                ]}
                                setResults={(data) => setSearchResults(data)}
                                debounceTime={750}
                                minMatchCharacters={1}
                                maxMatchCharacters={50}
                                disabled={false}
                                isCaseSensitive={false}
                                maxAcceptedScore={0.6}
                            />
                        </Section_Search>
                    ) : null}


                { customerClients.length > 0 ? <CardsSixty>
                    {displayedResults?.map((client) => {
                        return (
                            <On_Click_Card
                                title={`${client?.customerClient?.descriptiveName}`}
                                subtitle={`${client?.customerClient?.id}`}
                                onClick={() => handleSelection(client)}
                                id={"AdSnap_Google_Select_Client_2"}
                            />
                        );
                    })}
                </CardsSixty> : userHasData ? <Sixty_Card_Loader/> : "No data found" }
            </PageAlwaysVisible>
            <PageDesktopOnly>
                        <PageIllu>
                            <img src="https://genius1071.friktoriaservers.net/doitforme/morning/app/lois/HeaderAvatar.svg" />
                        </PageIllu>
            </PageDesktopOnly>
        </PageSixty> }
    </>
  );
};

export default CLIENTS;
